import { cn } from '@shared/lib/utils';
import { Badge } from './badge';

export interface CountBadgeProps {
  className?: string;
  count: number;
  label: string;
  overflowThreshold?: number;
  size?: 'sm' | 'md';
}

export function CountBadge({
  className,
  count,
  label,
  overflowThreshold = 99,
  size = 'sm',
}: CountBadgeProps) {
  const normalizedCount = Math.max(0, Math.trunc(count));
  const visibleCount =
    normalizedCount > overflowThreshold ? `${String(overflowThreshold)}+` : String(normalizedCount);

  return (
    <Badge
      appearance="outline"
      aria-label={label}
      className={cn('min-w-5 bg-background px-1 text-center tabular-nums', className)}
      data-count={normalizedCount}
      size={size}
    >
      {visibleCount}
    </Badge>
  );
}
